export default __webpack_public_path__ + "ec3f2e4ca2a10d4a46c59e99612c56a7.svg";